import * as React from "react"
import { cn } from "../../lib/utils"

export interface LogoIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string
  background?: string
  variant?: "default" | "gradient"
}

export const LogoIcon = React.forwardRef<SVGSVGElement, LogoIconProps>(
  ({ className, background, variant = "default", style, ...props }, ref) => {
    // Determine the fill color based on whether there's a background
    const fillColor = background ? "white" : "black"
    
    const svgElement = (
      <svg
        ref={ref}
        className={cn("w-4 h-4", className)}
        viewBox="0 -9 28 40"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
        {...props}
      >
        {/* Background with rounded corners - only if background prop is provided */}
        {background && (
          <rect
            width="40"
            height="40"
            rx="6"
            fill={variant === "gradient" ? "url(#gradient)" : "transparent"}
          />
        )}
        
        {/* Logo paths - centered and properly colored */}
        <g>
          <path
            d="M15.4006 14.9966L13.0788 11.5322H7.2615C6.0724 11.5322 5.10386 10.5557 5.10386 9.35408V7.2776C5.10386 6.07721 6.0712 5.09948 7.2615 5.09948H8.76706L6.45598 1.65199L1.54134 1.63989C1.51377 1.63989 1.4898 1.64957 1.46942 1.67014C1.44904 1.69072 1.43945 1.71492 1.43945 1.74396V14.8938C1.43945 14.9506 1.485 14.9966 1.54134 14.9966H15.4006Z"
            fill={fillColor}
          />
          <path
            d="M20.4646 18.4545C24.1134 18.4545 27.0814 15.4571 27.0814 11.7737C27.0814 8.09024 24.1134 5.09412 20.4646 5.09412L8.77734 5.10985L11.0896 8.55854H20.4646C22.2207 8.55854 23.6507 10.0009 23.6507 11.7749C23.6507 13.5489 22.2219 14.9913 20.4646 14.9913H15.4001L17.722 18.4557H20.4646V18.4545Z"
            fill={fillColor}
          />
        </g>

        {/* Gradient definition for gradient variant */}
        {variant === "gradient" && (
          <defs>
            <linearGradient
              id="gradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#8B5CF6" />
              <stop offset="100%" stopColor="#F59E0B" />
            </linearGradient>
          </defs>
        )}
      </svg>
    )

    // If background is provided, wrap in a div with the background
    if (background) {
      return (
        <div 
          className="inline-flex items-center justify-center rounded-lg p-2"
          style={{ background: variant === "gradient" ? undefined : background }}
        >
          {svgElement}
        </div>
      )
    }

    return svgElement
  }
)
LogoIcon.displayName = "LogoIcon" 